import { Box, InlineFormattedNumber, type InlineFormattedNumberProps } from '@talos/kyoko';
import type { ReactNode } from 'react';

const InspectorNumberFieldValue = ({ children }: { children: ReactNode }) => (
  <Box data-testid="instrument-inspector-section-field-value" textAlign="right">
    {children}
  </Box>
);

interface InspectorNumberDisplayProps {
  value?: InlineFormattedNumberProps['number'];
  currency?: InlineFormattedNumberProps['currency'];
  increment?: InlineFormattedNumberProps['increment'];
  showDashIfEmpty?: boolean;
  trimTrailingZeroes?: boolean;
}

/**
 * Keeps inspector number fields consistently right-aligned while preserving InlineFormattedNumber highlighting and empty-value behavior.
 */
export const InspectorNumberDisplay = ({
  value,
  currency,
  increment,
  showDashIfEmpty = true,
  trimTrailingZeroes,
}: InspectorNumberDisplayProps) => (
  <InspectorNumberFieldValue>
    <InlineFormattedNumber
      number={value}
      currency={currency}
      increment={increment}
      trimTrailingZeroes={trimTrailingZeroes}
      background="backgroundBlotterTableRowHover"
      highlightColor="colorTextImportant"
      showDashIfEmpty={showDashIfEmpty}
      align="right"
    />
  </InspectorNumberFieldValue>
);
